export default __webpack_public_path__ + "static/media/logo_white_yellow.6c52bad0.svg";